import React from 'react';
import Navbar from '../components/Navbar'
import HistoricoComponents from '../components/HistoricoComponents/HistoricoComponents';

const Historico = () => {
    return (
        <div>
            <Navbar />
            <HistoricoComponents />
                    </div>
    );
};

export default Historico